/**
 * Returns true if the current pathname is on the given route or any nested
 * descendant of it. Mirrors NavLink's default activeness rules but works
 * outside a NavLink (e.g. for "contains active child" checks on parents).
 */
export function isRouteActive(pathname: string, to: string): boolean {
  if (to === '/') return pathname === '/';
  return pathname === to || pathname.startsWith(`${to}/`);
}
